export default {
    'html, body': {
        fontSize: '14px',
    },
    ':focus': {
        outline: 0,
    },
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYm9keS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uLy4uLy4uL2FwZXgtb25saW5lL2NvbXBvbmVudC1saWJyYXJ5L3RoZW1lL2Nzcy9ib2R5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLGVBQWU7SUFDYixZQUFZLEVBQUU7UUFDWixRQUFRLEVBQUUsTUFBTTtLQUNqQjtJQUNELFFBQVEsRUFBRTtRQUNSLE9BQU8sRUFBRSxDQUFDO0tBQ1g7Q0FDRixDQUFBIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGRlZmF1bHQge1xuICAnaHRtbCwgYm9keSc6IHtcbiAgICBmb250U2l6ZTogJzE0cHgnLFxuICB9LFxuICAnOmZvY3VzJzoge1xuICAgIG91dGxpbmU6IDAsXG4gIH0sXG59XG4iXX0=